
import { defineComponent, PropType } from 'vue';
// Store
import { useManageBookingStore } from '@white-label-store/manage-booking';
import { ManageBookingParsedState } from '@white-label-types/stores';
import { mapState } from 'pinia';

import { print } from '@white-label-helper/print';
import { ACTION_METRIC, addCustomMetric, CONTEXT_KEYS, METRIC_TYPE } from '@white-label-helper/shared-helpers';

import BTicketShareButton from '../b-ticket-share-button/b-ticket-share-button.vue';
import ManageBookingModalEmailReceipt from '../manage-booking-modal-email-receipt/manage-booking-modal-email-receipt.vue';

export default defineComponent({
  name: 'ManageBookingShareButton',

  components: {
    BTicketShareButton,
    ManageBookingModalEmailReceipt,
  },
  props: {
    orderData: {
      type: Object as PropType<ManageBookingParsedState>,
      required: true,
    },
    shouldAlignLeft: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      displayEmailReceiptModal: false,
    };
  },

  computed: {
    ...mapState(useManageBookingStore,
      [
        'readIsPastBooking',
        'readUserEmail',
      ]
    ),
    isPastBooking() {
      return this.readIsPastBooking;
    },

    getUserEmail(): ReturnType<typeof readUserEmail> {
      return this.readUserEmail;
    },

    canResendConfirmationEmail(): boolean {
      // Authenticated users can resend past booking confirmations via `/account/receipt/resend`
      // Unauthenticated users can not resend past booking confirmations via `/booking/receipt/resend`
      return this.$auth.isAuthenticated || !this.isPastBooking;
    },

    orderEmailOptions(): Record<string, string>[] {
      const auth0UserEmail =
        this.$auth.isAuthenticated && this.$auth.user
          ? (this.$auth.user?.email as string)
          : '';

      const orderEmail = this.getUserEmail || '';

      // In future the user may be able to store multiple email addresses.
      // For now provide logged in user's email if available, or the order email as a fallback.
      if (auth0UserEmail) {
        return [{ value: auth0UserEmail }];
      }
      if (orderEmail) {
        return [{ value: orderEmail }];
      }
      return [];
    },
  },

  methods: {
    closeModal(): void {
      addCustomMetric(METRIC_TYPE.TRACKING, ACTION_METRIC.CLOSE_EMAIL_RECEIPT_MODAL, {
          modal_closed: this.displayEmailReceiptModal === false,
      }, null, CONTEXT_KEYS.MANAGE_BOOKING_SHARE_BUTTON);
      this.displayEmailReceiptModal = false;
    },

    printBookingReceipt(): void {
      addCustomMetric(METRIC_TYPE.TRACKING, ACTION_METRIC.PRINT_BOOKING_RECEIPT, {
        window_print: true,
      }, null, CONTEXT_KEYS.MANAGE_BOOKING_SHARE_BUTTON);
      print();
    },

    openEmailReceiptModal(): void {
      addCustomMetric(METRIC_TYPE.TRACKING, ACTION_METRIC.OPEN_EMAIL_RECEIPT_MODAL, {
          modal_opened: this.displayEmailReceiptModal === true,
      }, null, CONTEXT_KEYS.MANAGE_BOOKING_SHARE_BUTTON);
      this.displayEmailReceiptModal = true;
    },
  },
});
